import { render, staticRenderFns } from "./teamEdit.vue?vue&type=template&id=45fe6c98&scoped=true"
import script from "./teamEdit.vue?vue&type=script&lang=js"
export * from "./teamEdit.vue?vue&type=script&lang=js"
import style0 from "./teamEdit.vue?vue&type=style&index=0&id=45fe6c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe6c98",
  null
  
)

export default component.exports